import React from "react";
import "./stickyRow.css";

const StickyRow = (props) => {
  const { className, children } = props;
  return (
    <div className={className ? "sticky-row " + className : "sticky-row"}>
      {children}
    </div>
  );
};

export const StickyColumn = (props) => {
  const { children, width } = props;
  return (
    <div
      style={{
        flex: `1 1 ${width}`,
      }}
      className="sticky-row__sticky"
    >
      {children}
    </div>
  );
};

export const NonStickyColumn = (props) => {
  const { children, width } = props;
  return (
    <div
      style={{
        flex: `1 1 ${width}`,
      }}
      className="sticky-row__content"
    >
      {children}
    </div>
  );
};

export default StickyRow;
